export interface DropDownContainerItem {
    container: JQuery;
    dropdown: JQuery;
    textbox: JQuery;
    buttonafter: JQuery;
}

export class DropDownContainerList {
    lastSelected: number;
    containerList: Array<DropDownContainerItem>;
    $expandButton: JQuery;

    constructor(ddContainerList: Array<DropDownContainerItem>) {
        this.containerList = ddContainerList;
        this.lastSelected = 0;
    }

    setup() {
        // first thing is to see which dropdowns contain something. Hide the last one.
        for (var idx = 1; idx < this.containerList.length; ++idx) {
            const $dd = this.containerList[idx].dropdown;
            if ($dd) {
                const ddEl = <HTMLSelectElement> ($dd[0]);
                const selectedindex = ddEl.selectedIndex;
                if (selectedindex > 0) {
                    this.lastSelected = idx;
                }
            }
            const $txt = this.containerList[idx].textbox;
            if ($txt && $txt.val()) {
                this.lastSelected = idx;
            }
        }

        if (this.lastSelected >= this.containerList.length - 1) {
            return;
        }

        // hide everything after last selected
        for (idx = 0; idx < this.containerList.length; ++idx) {
            const $container = this.containerList[idx].container;
            if (idx >= this.lastSelected + 1) {
                $container.hide();
            } else {
                $container.show();
            }
        }

        // add expand button
        const self = this;
        let $ddFirst: JQuery;
        const firstContainer = this.containerList[0];
        if (firstContainer.buttonafter) {
            $ddFirst = firstContainer.buttonafter;
        } else if (firstContainer.dropdown) {
            $ddFirst = firstContainer.dropdown;
        } else {
            $ddFirst = firstContainer.textbox;
        }
        if ($ddFirst) {
            this.$expandButton = $(
                "<input type='button' class='formbutton marginleft' value='Add More' />",
            );
            $ddFirst.after(this.$expandButton);
            this.$expandButton.on("click", function () {
                self.doExpand();
            });
        }
    }

    doExpand() {
        this.lastSelected++;
        this.containerList[this.lastSelected].container.show();
        if (this.lastSelected >= this.containerList.length - 1) {
            this.$expandButton.hide();
        }
    }
}
